// extracted by mini-css-extract-plugin
module.exports = {"allSuggestedEditsLink":"styles__allSuggestedEditsLink___2C62Q","faIcon":"styles__faIcon___30x1k"};